import { useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { getParam } from '../utils/marketingHelper';

export const CROWN_RIPS_DEEP_LINK_VALUE = 'crown-rips';

/**
 * OneLink `deep_link_value=crown-rips`, shared with the mobile app. Waits for the boot like the slot-game link,
 * so a guest keeps it through sign-up, then hands off to /crown-rips, which opens the game.
 */
export const useCrownRipsDeepLink = (isBootReady: boolean) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isCrownRipsLink = getParam(searchParams, 'deep_link_value') === CROWN_RIPS_DEEP_LINK_VALUE;

  useEffect(() => {
    if (isBootReady && isCrownRipsLink) {
      navigate('/crown-rips', { replace: true });
    }
  }, [isBootReady, isCrownRipsLink, navigate]);
};
